<template>
    <div id="income">
        <div v-if="have">
            <ul class="incomeList" waterfall-disabled="disabled" waterfall-offset="200" v-waterfall-lower="loadMore">
                <li v-for="(item,index) in incomeList" :key="index">
                    <div class="money">+{{item.amount}}</div>
                    <div class="content">
                        <h4>{{item.des}}</h4>
                        <p class="time">{{item.create_time}}</p>
                    </div>
                </li>
            </ul>
            <p v-show="noMore" class="nomore">数据加载完成</p>
        </div>
        <div v-else class="nothing">
            <img :src="imgPath+'nothing.png'" alt="暂无数据">
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
import { Waterfall } from 'vant';
import { Toast } from 'vant';
    //保存数据

    export default {
        directives: {
          WaterfallLower: Waterfall('lower')
        },
        data() {
            return {
              fans_id:"",
              incomeList:[],
              have:true,
              page:1,
              page_nums:20,
              disabled:false,
              noMore:false,
              imgPath:''
            }
        },
        mounted() {
          var current_app_Id = window.localStorage.getItem("current_app_Id");
          var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
          this.fans_id = fans.fans_id;
          this.$toast.loading({duration:0});
          this.imgPath = tool.imgPath();
        },
        methods: {
            loadMore(){
              var that = this;
              var option = 'fans_id='+this.fans_id+'&type=income&page='+this.page+'&nums='+this.page_nums;
              Toast.loading({duration:0});
              this.disabled = true;
              this.axios.post(tool.baseUrl()+'/fans/finance/flow',option).then(function(data){
                Toast.clear();
                if(data.data.code == "200") {
                      that.incomeList = that.incomeList.concat(data.data.data);
                      that.page++;
                      if(that.incomeList.length == 0){
                          that.have = false;
                      }
                      if(data.data.data.length < that.page_nums){
                        that.disabled = true;
                        that.noMore = true;
                      }else{
                        that.disabled =false;
                      }
                  } else {
                    Toast(data.data.message)
                  }
              }).catch(function(res){
                Toast.clear();
                Toast(res.message)
              })
            }
        }
    }
</script>

<style scoped>
.incomeList li {
  padding: 10px;
  border-top: 1px solid #eee;
}

.incomeList .money {
  float: right;
  width: 60px;
  height: 30px;
  line-height: 30px;
  color: #33c533;
  text-align: right;
  font-size: 18px;
}

.incomeList .content {
  padding-right: 70px;
}

.incomeList h4 {
  font-weight: normal;
}

.incomeList p {
  font-size: 11px;
}

.incomeList .time {
  color: #999;
  margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// income.vue?21b42206